import { initializeApp } from "firebase/app";
import { getDatabase } from "firebase/database";

const firebaseConfig = {
  apiKey: "AIzaSyAq0QxSi2OjqKI8l-RMc1u9hFvWk1mkXlo",
  authDomain: "notes-h2ik.firebaseapp.com",
  databaseURL: "https://notes-h2ik-default-rtdb.firebaseio.com",
  projectId: "notes-h2ik",
  storageBucket: "notes-h2ik.appspot.com",
  messagingSenderId: "1078962578305",
  appId: "1:1078962578305:web:b762dba9dc1fa375ccfe80"
};

const app = initializeApp(firebaseConfig);
export const db = getDatabase(app);